import { apiFetch, apiFetchNoEncode, type ApiError } from './httpClient';
import apiActions from '../Actions/apiActions';
import commonActions from '../Actions/commonActions';
import { commonActionTypes } from '../ActionTypes/commonActionTypes';
import type { AppDispatch } from '../Store/types';

interface ApiThunkOptions {
    loadingKey?: string;
    init?: RequestInit;
    // Also reject (not resolve null) on failure, so a caller can roll back. Toast still fires.
    rethrow?: boolean;
    // The url is already fully encoded (e.g. a path segment through encodeURIComponent); skip apiFetch's encodeURI, which would encode '%' again.
    preEncoded?: boolean;
}

export function apiThunk<T = unknown>(url: string, options: ApiThunkOptions = {}) {
    return async (dispatch: AppDispatch): Promise<T | null> => {
        const setLoading = (value: boolean): void => {
            if (options.loadingKey !== undefined) {
                dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: options.loadingKey, value });
            } else {
                dispatch(commonActions.progressLoader(value));
            }
        };

        setLoading(true);
        try {
            return await (options.preEncoded === true ? apiFetchNoEncode<T>(url, options.init) : apiFetch<T>(url, options.init));
        } catch (error) {
            // the caller cancelled this request on purpose, so there is no failure to tell the user about
            if (options.init?.signal?.aborted !== true) {
                dispatch(apiActions.apiErrorOccurred(error as ApiError));
            }
            if (options.rethrow === true) {
                throw error;
            }
            return null;
        } finally {
            setLoading(false);
        }
    };
}
